import { Property, RepaymentStrategy } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { Endowment } from '../Endowment';
import { Investment } from '../Investment';
import { State, Action, Actions, createState } from './store';

const initialState: State = createState();

const setRepaymentStrategyData = function<T extends object>(repaymentStrategy: T) {
  return repaymentStrategy;
};

const setPropertiesFinish = (state: State, properties: Property[]): State['properties'] => {
  return state['properties'];
};

const setEndowmentsFinish = (state: State, items: Endowment[]): State['endowments'] => {
  return state['endowments'];
};

const setInvestmentsFinish = (state: State, items: Investment[]): State['investments'] => {
  return state['investments'];
};

const reducer = (state: State = initialState, action: Action) => {
  const map = new Map([
    // Getting data
    [
      Actions.SET_GETTING_DATA_START,
      () => ({
        ...state,
      }),
    ],
    [
      Actions.SET_GETTING_DATA_FINISH,
      () => {
        const { properties, endowments, investments, ...repaymentStrategy } = action.payload as RepaymentStrategy;
        return {
          ...state,
          data: setRepaymentStrategyData<typeof repaymentStrategy>(repaymentStrategy),
          isLoading: false,

          properties: setPropertiesFinish(state, properties),
          endowments: setEndowmentsFinish(state, endowments),
          investments: setInvestmentsFinish(state, investments),
        } as State;
      },
    ],

    // Updating data
    // [
    //   Actions.SET_UPDATING_DATA_START,
    //   () => ({
    //     ...state,
    //     data: setFieldIsLoading(state, { ...(action.payload as FieldPayload), payload: true }),
    //   }),
    // ],
    // [
    //   Actions.SET_UPDATING_DATA_FINISH,
    //   () => ({
    //     ...state,
    //     data: setFieldUpdated(state, action.payload as FieldPayload),
    //   }),
    // ],
    // [
    //   Actions.SET_UPDATING_DATA_ERROR,
    //   () => ({
    //     ...state,
    //     data: setFieldError(state, action.payload as FieldPayload),
    //   }),
    // ],

    // [
    //   Actions.SET_PROPERTIES_FINISH,
    //   () => ({
    //     ...state,
    //     properties: setPropertiesFinish(state, action.payload as Property[]),
    //   }),
    // ],
    // [
    //   Actions.ADD_PROPERTY,
    //   () => ({
    //     ...state,
    //     properties: addProperty(state, action.payload as Property),
    //   }),
    // ],
    // [
    //   Actions.REMOVE_PROPERTY,
    //   () => ({
    //     ...state,
    //     properties: removeProperty(state, action.payload as PropertyId),
    //   }),
    // ],

    // [
    //   Actions.SET_ENDOWMENTS_FINISH,
    //   () => ({
    //     ...state,
    //     endowments: setEndowmentsFinish(state, action.payload as Endowment[]),
    //   }),
    // ],
    // [
    //   Actions.ADD_ENDOWMENT,
    //   () => ({
    //     ...state,
    //     endowments: addEndowment(state, action.payload as Endowment),
    //   }),
    // ],
    // [
    //   Actions.REMOVE_ENDOWMENT,
    //   () => ({
    //     ...state,
    //     endowments: removeEndowment(state, action.payload as EndowmentId),
    //   }),
    // ],

    // [
    //   Actions.SET_INVESTMENTS_FINISH,
    //   () => ({
    //     ...state,
    //     investments: setInvestmentsFinish(state, action.payload as Investment[]),
    //   }),
    // ],
    // [
    //   Actions.ADD_INVESTMENT,
    //   () => ({
    //     ...state,
    //     investments: addInvestment(state, action.payload as Investment),
    //   }),
    // ],
    // [
    //   Actions.REMOVE_INVESTMENT,
    //   () => ({
    //     ...state,
    //     investments: removeInvestment(state, action.payload as InvestmentId),
    //   }),
    // ],
  ]);

  const actionCallback = map.get(action.type);

  return actionCallback && typeof actionCallback === 'function' ? actionCallback() : state;
};

export default reducer;
